import * as React from 'react';
import { useSelector } from 'react-redux';

import { BrokerConsultantBanner } from '../../components/BrokerConsultantBanner';
import { BrokerFlightBanner } from '../../components/BrokerFlightBanner';
import {
  selectBrokerConsultantBannerButtonText,
  selectBrokerConsultantBannerUrl,
  selectBrokerFlightEnabled,
} from '../../selectors/brokerConsultantBanner';

export const BrokerConsultantBannerContainer: React.FC = () => {
  const url = useSelector(selectBrokerConsultantBannerUrl) as string;
  const buttonText = useSelector(selectBrokerConsultantBannerButtonText);
  const isFlightEnabled = useSelector(selectBrokerFlightEnabled);

  // TODO: Удалить в CD-251393.
  if (isFlightEnabled) {
    return <BrokerFlightBanner url={url} buttonText={buttonText} />;
  }

  return <BrokerConsultantBanner url={url} buttonText={buttonText} />;
};
